import React, { useRef, useState } from "react";
import {
  Typography,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Grid,
} from "@mui/material";
import { styled } from "@mui/system";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import uploadImage from "../image/upload.png";
import cameraIcon from "../image/cameraIcon.png";
export const ImportButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#e63e57",
  color: "white",
  "&:hover": {
    backgroundColor: "#E9535D",
  },
  borderRadius: "10px",
  height: "50px",
  padding: theme.spacing(1),
}));

const TextStyle = {
  marginTop: "5%",
  fontWeight: "bold",
  fontSize: "2rem",
};

const PhotoImportCard = ({ AddImage, affichage,event }) => {
  const fileInputRef = useRef(null);
  const cameraInputRef = useRef(null);
  const [openDialog, setOpenDialog] = useState(false);

  const handleButtonClick = () => {
      fileInputRef.current.click(); // Directly open file selector when event is false
  };



  const handleOpenCamera = () => {
    cameraInputRef.current.click();
    setOpenDialog(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderColor: "#f7f7f7",
        textAlign: "center",
        padding: "20px",
        gap: "20px",
      }}
    >
      <ImportButton
        variant="contained"
        onClick={handleButtonClick}
        startIcon={<AddPhotoAlternateIcon />}
      >
        Importer des photos
      </ImportButton>
      {event && (
      <ImportButton
        variant="contained"
        onClick={handleOpenCamera}
        startIcon={<AddPhotoAlternateIcon />}
      >
      Prendre photo
      </ImportButton>
      )}
  

      {affichage && (
        <>
          <Typography variant="h4" sx={TextStyle} gutterBottom>
            Choisissez vos photos préférées! 🔥
          </Typography>
          <Typography variant="body1" sx={{ fontSize: "1rem" }}>
            Nous acceptons les fichiers JPEG, JPG, PNG et HEIC (seulement sur
            iOS et MacOS), jusqu'à 100 Mo.
          </Typography>
        </>
      )}

      {/* File Input for selecting from gallery */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/*"
        multiple
        onChange={AddImage}
      />

      {/* File Input for taking a photo */}
      <input
        type="file"
        ref={cameraInputRef}
        style={{ display: "none" }}
        accept="image/*"
        capture="environment"
        onChange={AddImage}
      />

  
    </Box>
  );
};

export default PhotoImportCard;
